<template>
  <!-- 帮帮-找帮帮 - xxx商品详情 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBackHome">帮帮</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBackHome">来帮帮</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">详情</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- -->
        <div class="top-title">
          <p class="title">招标详情</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="switch-Content">
          <p class="title-p">招标信息</p>
          <div class="mine-attendContent">
            <CallForBidsMsg></CallForBidsMsg>
          </div>
          <p class="title-p">参标信息</p>
          <div class="attendContent">
            <AttendContent :distinguish="2" :listArr="listArr"></AttendContent>
          </div>
          <!-- 分页 -->
          <div class="paging-box">
            <div class="paging">
              <paging
                :pagingObj="pagingObj"
                @handleCurrentChange="handleCurrentChange"
              ></paging>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部按钮 -->
      <div class="Bottom-Btn">
        <div>
          <p class="firm-clickable" @click="handelTender">投标</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallForBidsMsg from "../HelpShop/moduleFour/components/CallForBidsMsg.vue"; //招标信息
import AttendContent from "../HelpShop/moduleFour/components/AttendContent.vue"; //参标信息
import paging from "../../../../components/paging.vue"; // 分页
export default {
  data() {
    return {
      reveal: "1", ////1投标  2确认投标
      listArr: [
        {
          name: "张xx", //姓名
          address: "河南 南阳", //地址
          type: "个人", //个人/企业
          serviceType: "后端开发、LOGO设计、小程序、web网站…", //服务类型
          SalesVolume: "12354", //销量
          mark: 4, //星级
          HitHit: false, //是否中标
          id: 1,
        },
        {
          name: "张xx", //姓名
          address: "河南 南阳", //地址
          type: "企业", //个人/企业
          serviceType: "后端开发、LOGO设计、小程序、web网站…", //服务类型
          SalesVolume: "12354", //销量
          mark: 3, //星级
          HitHit: true, //是否中标
          id: 2,
        },
      ], //参标信息
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
    };
  },
  watch: {},
  components: {
    CallForBidsMsg, //招标信息
    AttendContent, //参标信息
    paging,
  },
  created() {},
  destroyed() {},
  methods: {
    // 点击面包屑返回
    handelBackHome() {
      this.$router.push({
        path: "/HelpShop/Help",
        query: { key: 2 },
      });
    },
    // 点击投标
    handelTender() {
      this.$router.push({
        path: "/HelpShop/Help/ComeBid",
      });
    },
    // 返回
    handelBack() {
      this.$router.push({
        path: "/HelpShop/Help",
        query: { key: 2 },
      });
    },

    // 分页
    handleCurrentChange(val) {
      // 获取 用户点击的页码/输入的页码
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  //
  .switch-Content {
    width: 100%;
    margin-top: 30px;
    // 招标信息 参标信息 标题
    .title-p {
      width: 85px;
      height: 25px;
      background-image: url("../../../../assets/imgs/zhuangshi@3x.svg");
      background-size: 100% 35%;
      background-repeat: no-repeat;
      background-position-y: bottom;
      font-size: 20px;
      margin: 50px 0px 30px 0px;
    }
    // 表单输入区
    .Price {
      width: 500px;
      height: 35px;
      line-height: 35px;
      display: flex;
      margin-top: 50px;
      margin-bottom: 30px;
      .ipt {
        flex: 1;
      }
    }
    // 交付方式
    .InputLine {
      width: 100%;
      background: #eeeeee;
      min-height: 35px;
      padding: 10px 0px 10px 0px;
      display: flex;
      .title-box {
        width: 80px;
        margin: auto 0;
        text-align: center;
        margin-left: 10px;
        div {
          width: 50px;
          height: 18px;
          line-height: 18px;
          display: flex;
          font-size: 12px;
          color: #333333;
          margin: 0 auto;
          margin-top: 5px;
          p {
            width: 18px;
            height: 18px;
            background-image: url("../../../../assets/imgs/tianjia@3x.svg");
            background-size: 100% 100%;
            margin-right: 5px;
          }
        }
      }
      // 内容输入区
      .content {
        flex: 1;
        min-height: 35px;
        margin-left: 20px;
        .CycleBody:nth-child(1) {
          margin-top: 0px;
        }
        .CycleBody {
          width: 100%;
          height: 35px;
          margin-top: 10px;
          display: flex;
          // 第一列
          .column-one {
            width: 120px;
            min-height: 35px;
            position: relative;
            .delete-icon {
              width: 16px;
              height: 17px;
              background-image: url("../../../../assets/imgs/shanchu@3x.svg");
              background-size: 100% 100%;
              position: absolute;
              right: 5px;
              top: 8px;
            }
          }
          // 第二长列
          .LongColumn {
            flex: 1;
            height: 35px;
            margin-left: 10px;
            margin-right: 10px;
            display: flex;
            // 支付方式  选择 全款二期三期
            .delivery {
              width: 210px;
              height: 25px;
              margin: auto;
              display: flex;
              div {
                width: 66px;
                height: 25px;
                line-height: 25px;
                text-align: center;
                background: #ffffff;
                font-size: 12px;
                color: #666666;
              }
              div:nth-child(1) {
                border-radius: 15px 0px 0px 15px;
                border: 1px solid #409eff ;
              }
              div:nth-child(2) {
                border-top: 1px solid #409eff ;
                border-bottom: 1px solid #409eff ;
              }
              div:nth-child(3) {
                border-radius: 0px 15px 15px 0px;
                border: 1px solid #409eff ;
              }
              .TimeLimit {
                color: #ffffff;
                background: #409eff ;
              }
            }
            //需要付
            .period-title {
              width: 100%;
              min-height: 35px;
              line-height: 35px;
              display: flex;
              background: rgba(97, 144, 232, 0.2);
              border: 1px solid #409eff ;
              border-radius: 5px;
              .period-title-cen {
                width: 150px;
                margin: auto;
                display: flex;
                font-size: 12px;
                color: #409eff ;
                /deep/.el-input {
                  height: 35px !important;
                  width: 60px;
                  border: none;
                }
                /deep/.el-input__inner {
                  height: 35px !important;
                  width: 60px;
                  border: none !important;
                  background: transparent;
                }
              }
            }
            // 一行一个输入框  独占一行
            .aloneContent {
              width: 100%;
              height: 35px;
            }
            // 一行二个输入框
            .service-ipt {
              width: 100%;
              height: 35px;
              display: flex;
              .people-num {
                width: 300px;
                height: 35px;
              }
              .people-name {
                flex: 1;
                height: 35px;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
  // 招标信息
  .mine-attendContent {
    width: 100%;
    min-height: 200px;
  }
  .attendContent {
    width: 100%;
    min-height: 600px;
  }
}
.Bottom-Btn {
  height: 35px;
  background: #ffffff;
  box-shadow: 0px -5px 10px 0px rgba(153, 153, 153, 0.5);
  border-radius: 0px 0px 20px 20px;
  margin-top: -30px;
  margin-bottom: 20px;
  display: flex;
  padding: 20px;
  p {
    width: 120px;
    height: 40px;
    background: #409eff ;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin: auto 0;
    margin-left: 20px;
  }
  div {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
